import React, { MouseEventHandler } from "react";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface ISearchResultCardProps {
  title: string;
  description: string;
  timeTag: string;
  categoryTag: string;
  categoryTagColour: "purple" | "green" | "blue" | "gray" | "red" | "yellow";
  image: IContentfulImage & ImageDataLike;
  url: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const SearchResultCard = ({
  title,
  description,
  timeTag,
  categoryTag,
  categoryTagColour,
  image,
  url,
  onClick,
}: ISearchResultCardProps) => (
  <a href={url} className="search-result-card-link" onClick={onClick}>
    <div className="search-result-card">
      <div className="search-result-card-wrapper">
        <h1 className="search-result-card-wrapper-title">{title}</h1>
        <h2 className="search-result-card-wrapper-description">{description}</h2>
        <div className="search-result-card-wrapper-tags">
          <div className={`search-result-card-wrapper-tags-${categoryTagColour}`}>
            {categoryTag}
          </div>
          <div>
            {timeTag}
            {" "}
            minute read
          </div>
        </div>
      </div>
      {image && (
        <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} className="search-result-card-image" />
      )}
    </div>
  </a>
);
